export default __webpack_public_path__ + "static/media/Imagen_Concierge_via_whatsapp.6d4f39a7.png";